import PropTypes from 'prop-types'
import React from 'react'
import { FormattedMessage } from 'react-intl'
import { reduxForm, Field } from 'redux-form'
import {
  FormGroup,
  ControlLabel,
  FormControl,
  HelpBlock,
  Button,
  ButtonGroup
} from 'react-bootstrap'

export class AddDocumentFromTemplateForm extends React.Component {
  static propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    submitting: PropTypes.bool.isRequired,
    onCancelClick: PropTypes.func.isRequired
  }

  constructor (props) {
    super(props)

    this.renderField = this.renderField.bind(this)
  }

  renderField (field) {
    const onInputFocus = (event) => {
      const tempValue = event.target.value
      event.target.value = ''
      event.target.value = tempValue
    }

    return (
      <FormGroup
        validationState={field.meta.touched && field.meta.error ? 'error' : null}>
        <ControlLabel><FormattedMessage id='NAME' /></ControlLabel>
        <FormControl
          {...field.input}
          name={null}
          type='text'
          autoFocus
          onFocus={onInputFocus}
        />
        {field.meta.touched && field.meta.error && <HelpBlock>{field.meta.error}</HelpBlock>}
      </FormGroup>
    )
  }

  render () {
    const { handleSubmit, submitting, onCancelClick } = this.props

    return (
      <form onSubmit={handleSubmit}>
        <Field
          name='name'
          component={this.renderField}
        />
        <ButtonGroup>
          <Button type='submit' bsStyle='primary' disabled={submitting}><FormattedMessage id='ADD' /></Button>
          <Button onClick={onCancelClick}><FormattedMessage id='CANCEL' /></Button>
        </ButtonGroup>
      </form>
    )
  }
}

export default reduxForm({
  form: 'addDocumentFromTemplate'
})(AddDocumentFromTemplateForm)
